var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"framework-text",class:{'is-error': _vm.error},style:(_vm.styles)},[(_vm.text)?[_vm._v(_vm._s(_vm.text))]:[_vm._v(_vm._s(!_vm.isEmpty ? _vm.value : '————'))],_vm._v(" "),(_vm.$slots.default && !_vm.isEmpty)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cb0d2ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/widgets/text.vue
// module id = null
// module chunks = 